import { render } from "./EditableName.vue?vue&type=template&id=d7ef4702&ts=true"
import script from "./EditableName.vue?vue&type=script&lang=ts"
export * from "./EditableName.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__